import { render, staticRenderFns } from "./AS2PdRes.vue?vue&type=template&id=cc6dc3ce&scoped=true&"
import script from "./AS2PdRes.vue?vue&type=script&lang=js&"
export * from "./AS2PdRes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6dc3ce",
  null
  
)

export default component.exports